import React, { useState, useEffect } from "react";
import css from "./Pictures.module.css";
import employee from "../../images/employees.png";
import money from "../../images/money.png";
import school from "../../images/learners.png";

const Image = () => {
  const [counter, setCounter] = useState(0);

  let wmcaPic = [employee, money, school];

  useEffect(() => {
    function updatePic() {
      if (counter === wmcaPic.length - 1) {
        setCounter(0);
      } else {
        setCounter(counter + 1);
      }
    }
    const interval = setInterval(() => {
      updatePic();
    }, 2000);
    return () => clearInterval(interval);
  }, [counter, wmcaPic.length]);

  return <img src={wmcaPic[counter]} className={css.picture} alt="WMCA"></img>;
};

export default Image;
